/* ============================================
   THE DRAW — PAGE 2 — Interactions
   ============================================ */

(function () {
  document.addEventListener("DOMContentLoaded", function () {

    /* ---------- expandable sections (single-open accordion,
       same behavior as FK U** Rings Page 2) ---------- */
    var exps = document.querySelectorAll(".tdp-exp");
    exps.forEach(function (exp) {
      var header = exp.querySelector(".tdp-exp-header");
      var icon = exp.querySelector(".tdp-exp-icon");
      header.addEventListener("click", function () {
        var willOpen = !exp.classList.contains("open");
        exps.forEach(function (e) {
          e.classList.remove("open");
          var i = e.querySelector(".tdp-exp-icon");
          if (i) i.innerHTML = "&plus;";
        });
        if (willOpen) {
          exp.classList.add("open");
          if (icon) icon.innerHTML = "&minus;";
        }
      });
    });

    /* ---------- image gallery: main image + thumbs + arrows ---------- */
    var mainImgs = Array.prototype.slice.call(document.querySelectorAll(".tdp-main-img"));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll(".tdp-thumb"));
    var prevBtn = document.getElementById("tdpPrev");
    var nextBtn = document.getElementById("tdpNext");
    var current = 0;

    function showImage(index) {
      if (mainImgs.length === 0) return;
      index = ((index % mainImgs.length) + mainImgs.length) % mainImgs.length;
      current = index;
      mainImgs.forEach(function (img, i) {
        img.classList.toggle("is-active", i === index);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle("is-selected", i === index);
      });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () { showImage(i); });
    });
    if (prevBtn) prevBtn.addEventListener("click", function () { showImage(current - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { showImage(current + 1); });

    /* Jump to a matching photo by alt-text keyword when a color is
       selected — same mechanism as FK U** Rings Page 2. If no image
       has matching alt text yet, this silently does nothing and
       stays on the current photo, so it degrades gracefully until
       a matching photo is uploaded. */
    function jumpToKeyword(keyword) {
      if (!keyword) return;
      var idx = mainImgs.findIndex(function (img) {
        return (img.getAttribute("alt") || "").toLowerCase().indexOf(keyword) !== -1;
      });
      if (idx !== -1) showImage(idx);
    }

    /* ---------- color swatches ---------- */
    var swatches = document.querySelectorAll(".tdp-swatch");
    var variantInput = document.getElementById("tdpVariantId");

    swatches.forEach(function (btn) {
      btn.addEventListener("click", function () {
        swatches.forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");
        if (variantInput) variantInput.value = btn.dataset.variantId;
        jumpToKeyword(btn.dataset.keyword);
      });
    });

    /* ---------- add to cart ---------- */
    var form = document.getElementById("tdpForm");
    var confirmEl = document.getElementById("tdpAtcConfirm");
    var atcBtn = document.getElementById("tdpAtc");

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (confirmEl) confirmEl.hidden = false;
            if (atcBtn) atcBtn.disabled = true;
            setTimeout(function () {
              if (confirmEl) confirmEl.hidden = true;
              if (atcBtn) atcBtn.disabled = false;
            }, 2200);
          })
          .catch(function (err) {
            console.error("Add to cart failed:", err);
          });
      });
    }

  });
})();
